import { render, staticRenderFns } from "./playNew_repair.vue?vue&type=template&id=06b82180&scoped=true&"
import script from "./playNew_repair.vue?vue&type=script&lang=js&"
export * from "./playNew_repair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b82180",
  null
  
)

export default component.exports